import { tokenValidationInterval } from '../constants';
import { getTokenMillisecondsLeft } from '../utilities/get-token-milliseconds-left';
/**
 * Validates JWT for not being expired. Returns `false` if JWT is about to be expired (5 minutes left).
 * @param token JWT to validate
 * @returns A boolean value indicating whether provided JWT is either expired or is about to be expired.
 */
export var validateJWTToken = function (token) {
    var tokenMillisecondsLeft = getTokenMillisecondsLeft(token);
    return tokenMillisecondsLeft > tokenValidationInterval;
};
